import { IScope, IRootScopeService } from "angular";
import { SupportedUpdateItem } from "@gtmhub/shared/services/updateService";
import { CustomFieldTargetType } from "./models/models";
import { CfMap } from "./components/editable-custom-fields/editable-custom-fields";

interface IBroadcastItemChangesArgs {
  item: SupportedUpdateItem;
  type: CustomFieldTargetType;
}

export interface IItemUpdatedArgs extends IBroadcastItemChangesArgs {
  update: Partial<SupportedUpdateItem | CfMap>;
}

export class ItemEvents {
  private $rootScope: IRootScopeService;
  constructor(private $scope: IScope) {
    this.$rootScope = this.$scope.$root;
  }

  public broadcastItemUpdated(args: IItemUpdatedArgs): void {
    this.$rootScope.$broadcast("itemUpdated", args);
  }

  onItemUpdated(callback: (args: IItemUpdatedArgs) => unknown): void {
    this.$scope.$on("itemUpdated", (evt, args: IItemUpdatedArgs) => callback(args));
  }
}
